module.exports = __webpack_public_path__ + "img/easy-use.e97cf24c.svg";